import { BoxLocation } from "./box-location";
import { Model } from "./model";

export class PatchBox extends Model {

  enabled?: boolean;

  hardwareVersion?: string;

  identifier?: string;

  softwareVersion?: string;

  status?: string;

  boxLocation?: BoxLocation

}
